import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Heading from '../Heading';
import InnerWrapper from '../../global/InnerWrapper';
import BaseNewsExcerpt from '../../global/NewsExcerpt';
import NewsFeature from '../../global/NewsFeature';

const Article = styled.div`
  width: 31%;

  & + & {
    margin: 0 0 0 3.5%;
  }

  & > :first-child {
    display: none;
  }
  & > :last-child {
    display: flex;
  }

  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    width: 100%;
    & + & {
      margin: 0;
    }
    & > :first-child {
      display: block;
    }
    & > :last-child {
      display: none;
    }
  }
`;

const ArticlesWrapper = styled.div`
  display: flex;

  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    flex-direction: column;
  }
`;

const NewsExcerpt = styled(BaseNewsExcerpt)`
  width: 100%;
`;

const renderNewsItem = (article, index, showDivider) => (
  <Article key={index}>
    <NewsExcerpt
      id={article.slug}
      imageUrl={article.thumbnail}
      title={article.title}
      description={article.description}
      divider={showDivider}
    />
    <NewsFeature
      buttonText="Read More"
      categoryHeader={article.type}
      description={article.description}
      heading={article.title}
      id={article.slug}
      image={{ alt: article.title, src: article.thumbnail }}
    />
  </Article>
);

const RelatedNewsSection = ({ articles }) => (
  <InnerWrapper>
    <Heading hideOnMobile>Related News</Heading>
    <ArticlesWrapper>
      {articles.map((a, i) => renderNewsItem(a, i, i < articles.length - 1))}
    </ArticlesWrapper>
  </InnerWrapper>
);

RelatedNewsSection.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RelatedNewsSection;
